import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Accueil.css';
import AccueilButtons from './Components/Accueil-buttons';
import { getPlayerProfile, getSessionTicket, getPlayFabId } from './api';
import { useEvents } from './EventContext';

function Accueil() {
    const animationRef = useRef([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [displayName, setDisplayName] = useState(null);
    const [showDisplayName, setShowDisplayName] = useState(false);
    const [quizInstanceId, setQuizInstanceId] = useState(null); // État pour l'ID du quiz
    const [eventActive, setEventActive] = useState(false); // État pour savoir si un événement est actif
    const navigate = useNavigate();
    
    // Vérification du statut de l'événement dans le localStorage au démarrage
    useEffect(() => {
        const savedEventStatus = localStorage.getItem('eventActive');
        if (savedEventStatus === 'true') {
            setEventActive(true);
        }
    }, []);

    // Use the EventContext instead of useRealTime
    const { events, lastEvent } = useEvents();
    
    // React to events
    useEffect(() => {
        if (!lastEvent) return;
        
        console.log('Event received in Accueil:', lastEvent);
        
        // Check if the event is a quiz start
        if (lastEvent.EventName === 'match_survey_instantiated' || lastEvent.EventName === 'quiz_start') {
            const QuizInstanceId = lastEvent.quizInstanceId || lastEvent.QuizInstanceId;
            console.log('QuizInstanceId received:', QuizInstanceId);
            setQuizInstanceId(QuizInstanceId);
            setEventActive(true); // Indicate that an event is active
            localStorage.setItem('eventActive', 'true'); // Persist the event state
        }
        
        // Hide the button when the event is finished or expired
        if (lastEvent.EventName === 'match_survey_ended' || lastEvent.EventName === 'quiz_end') {
            setQuizInstanceId(null);
            setEventActive(false); // The event has ended
            localStorage.removeItem('eventActive'); // Remove the event state from localStorage
            console.log("Event ended");
        }
    }, [lastEvent]);

    useEffect(() => {
        const fetchPlayerProfile = async () => {
            const playFabId = localStorage.getItem('playFabId');
            if (!playFabId) {
                setError('PlayFabId introuvable.');
                setLoading(false);
                return;
            }

            try {
                const { displayName } = await getPlayerProfile(playFabId);
                setDisplayName(displayName);
                localStorage.setItem('displayName', displayName);
                
                setTimeout(() => {
                    setShowDisplayName(true);
                }, 50);
            } catch (err) {
                setError('Erreur lors de la récupération du nom d\'utilisateur');
            } finally {
                setLoading(false);
            }
        };

        fetchPlayerProfile();
    }, [navigate]);

    // Fonction pour rejoindre manuellement le quiz
    const handleJoinQuiz = () => {
        if (quizInstanceId) {
            navigate(`/survey/${quizInstanceId}`);
        }
    };

    return (
        <div className="Accueil-container">
            {/* Contenu de la page Frame 52 */}
            <div className="Rectangle56"></div>
            <div className="Rectangle102"></div>
            <div className="Rectangle103"></div>
            <div className="Rectangle114"></div>
            <div className="Rectangle109"></div>
            <div className="Rectangle110"></div>
            <div className="Rectangle108"></div>
            <div className="Rectangle107"></div>
            <div className="Rectangle104"></div>
            <div className="Rectangle101"></div>
            <div className="Rectangle78"></div>
            <div className="Rectangle111"></div>
            <div className="Rectangle106"></div>
            
            {/* Affichage du statut de l'événement */}
        <div className="animated-rectangle">
            {/* Texte dynamique basé sur l'état de l'événement */}
            <div className="animated-text">
                { "Aucun évènement en cours"}
            </div>
            <div className="animated-text1">
                { "Suivez l’action et gardez l’œil ouvert pour un vote ou un quiz dans cet espace."}
            </div>
        </div>

        <div className="Int">.Int</div>

        {/* Affichage du nom d'utilisateur une fois qu'il est chargé */}
        {!loading && displayName && (
            <h1 className={`displayName ${showDisplayName ? 'show' : ''}`}>
                Bonjour, {displayName}!
            </h1>
        )}
        {loading && <p>Chargement...</p>}
        {error && <p className="error">{error}</p>}

        {/* Affichage des boutons d'Accueil */}
        <AccueilButtons />

        {/* Afficher un bouton "Rejoindre l'événement" si un événement est en cours */}
        {eventActive && (
            <div className="event-active">
                <p>Un événement est en cours !</p>
                {quizInstanceId && (
                    <button className="join-button" onClick={handleJoinQuiz}>
                        Rejoindre le vote
                    </button>
                )}
            </div>
        )}

            {/* Animations Lottie */}
            <div className="animation-container">
                <dotlottie-player
                    ref={el => animationRef.current[0] = el}
                    src="https://lottie.host/8a81eaba-238c-4097-a547-1715c0e104b0/EP2Q1DsE1I.json"
                    background="transparent"
                    speed="0.9"
                    style={{ width: '382px', height: '523px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
           
            <div className="animation-container2">
                <dotlottie-player
                    ref={el => animationRef.current[2] = el}
                    src="https://lottie.host/ef8ca5d4-08bc-4f4c-85b0-63b4c12bef43/jt0pYwK00Y.json"
                    background="transparent"
                    speed="1"
                    style={{ width: '106px', height: '219px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container3">
                <dotlottie-player
                    ref={el => animationRef.current[3] = el}
                    src="https://lottie.host/a18a3aa6-3e73-4289-bb75-12be2f2d86fa/Bi4V4CAv7M.json"
                    background="transparent"
                    speed="1.3"
                    style={{ width: '92px', height: '219px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container4">
                <dotlottie-player
                    ref={el => animationRef.current[4] = el}
                    src="https://lottie.host/0ca841da-5e7f-41bf-af0e-3b131815857d/3jJq7FHRpk.json"
                    background="transparent"
                    speed="1.2"
                    style={{ width: '185px', height: '485px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
           
            <div className="animation-container6">
                <dotlottie-player
                    ref={el => animationRef.current[6] = el}
                    src="https://lottie.host/d552010e-2a93-46fa-bd36-9a335986c941/02uA55p797.json"
                    background="transparent"
                    speed="0.5"
                    style={{ width: '371.5px', height: '12px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container7">
                <dotlottie-player
                    ref={el => animationRef.current[7] = el}
                    src="https://lottie.host/d50e6e1f-8fb8-45e1-9134-8d8c0c782d34/BXtmN4gWm2.json"
                    background="transparent"
                    speed="1.2"
                    style={{ width: '91px', height: '155px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container8">
                <dotlottie-player
                    ref={el => animationRef.current[8] = el}
                    src="https://lottie.host/bd60766a-d542-4a06-bdcb-5c08c66bb283/eGwIxrRATB.json"
                    background="transparent"
                    speed="1.2"
                    style={{ width: '60.25px', height: '55px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
        </div>
    );
}

export default Accueil;
